<div class="card">
    <div class="card-header mm-card-header">
        Link {{ enterpriseLabels.accountLabel }} (Optional)
    </div>
    <div class="card-body col-md-12">
        <div class="row">
            <div class="col-sm-5 ps-2">
                <span class="form-label mm-label mb-0">Sites</span>
            </div>
            <div class="col-sm-5 ps-2">
                <span class="form-label mm-label mb-0">Account</span>
            </div>
            <div class="col-md-2"></div>
        </div>

        <div *ngFor="let row of rows.controls; let i = index" [formGroup]="row" class="row mb-3" >
            <div class="col-md-5 ps-2">
                <lib-organization-search
                    id="organization-{{ i }}"
                    [enterpriseId]="currentEnterpriseId"
                    [truncateText]="true"
                    (newOrganizationSelectedEvent)="selectedOrganizationChanged($event, i)">
                </lib-organization-search>
                <div *ngIf="rows.at(i).get('selectedOrganization')?.invalid && rows.at(i).get('selectedOrganization')?.touched" class="text-danger">
                    * Organization is required.
                </div>
            </div>
            <div class="col-md-5 ps-2">
                <mmoga-ema-account-search
                    id="emaAccount-{{ i }}"
                    [selectedOrganization]="row.get('selectedOrganization')?.value"
                    [alreadySelectedEmaAccountIds]="getSelectedEmaAccountIds()"
                    (newEmaAccountSelectedEvent)="selectedEmaAccountChanged($event, i)">
                </mmoga-ema-account-search>
                <div *ngIf="rows.at(i).get('selectedEmaAccount')?.invalid && rows.at(i).get('selectedEmaAccount')?.touched && !rows.at(i).get('selectedOrganization')?.invalid" class="text-danger">
                    * Account is required.
                </div>
            </div>
            <div class="col-md-2 text-end">
                <a class="text-decoration-none remove-link" href="#" (click)="removeRow($event, i)">Remove</a>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 text-start">
                <button
                    type="button"
                    class="btn btn-sm btn-outline-primary"
                    data-identifier="add-ema-account-row-id-btn"
                    (click)="addRow()">
                    Add Account
                </button>
            </div>
        </div>
    </div>
</div>
